import { useEffect } from 'react';

const useClickOutside = (refs: any[], callback: () => void) => {
  const handleClick = (e: any) => {
    // ignore a click on one of our 3rd party libraries like react-datepicker or multiselect-react-dropdown
    if (e.target.closest('.react-datepicker') || e.target.closest('.chip') || e.target.closest('.option')) {
      return;
    }

    const inTarget = refs.some((ref: any) => ref.current && ref.current.contains(e.target));

    if (!inTarget) callback();
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};

export default useClickOutside;
